var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0001 12.087V37.9565C42.0001 38.7637 41.6794 39.5378 41.1087 40.1086C40.5379 40.6794 39.7638 41 38.9566 41H10.0436C9.23639 41 8.46227 40.6794 7.89151 40.1086C7.32074 39.5378 7.00009 38.7637 7.00009 37.9565V12.087H42.0001Z",
    fill: "#D9EEF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2827 35.6739H39.7175",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.174 37.9565V33.3913",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5435 25.0217L21.4565 28.0652V21.9782L27.5435 25.0217Z",
    fill: "#D9EEF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9566 17.4131V32.6304H10.0436V17.4131C10.0448 17.0098 10.2055 16.6235 10.4906 16.3383C10.7757 16.0532 11.1621 15.8925 11.5653 15.8913H37.4349C37.8381 15.8925 38.2245 16.0532 38.5096 16.3383C38.7947 16.6235 38.9554 17.0098 38.9566 17.4131Z",
    fill: "#4C5B66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9566 32.6304V17.4131C38.9554 17.0098 38.7947 16.6235 38.5096 16.3383C38.2245 16.0532 37.8381 15.8925 37.4349 15.8913H11.5653C11.1621 15.8925 10.7757 16.0532 10.4906 16.3383C10.2055 16.6235 10.0448 17.0098 10.0436 17.4131V32.6304",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9764 27.5711C23.3216 28.0949 22.3517 27.6287 22.3517 26.7902V22.3581C22.3517 21.5196 23.3216 21.0534 23.9764 21.5773L26.7464 23.7933C27.2468 24.1936 27.2468 24.9547 26.7464 25.355L23.9764 27.5711Z",
    fill: "#59A5EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9565 6H10.0435C8.36261 6 7 7.36261 7 9.04348V37.9565C7 39.6374 8.36261 41 10.0435 41H38.9565C40.6374 41 42 39.6374 42 37.9565V9.04348C42 7.36261 40.6374 6 38.9565 6Z",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2827 12.087H39.7175",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0436 9.04349H11.5653",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.087 9.04349H14.6088",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4349 9.04349H38.9566",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40 6C41.1046 6 42 6.89543 42 8V37.3158C42 38.2929 41.6793 39.23 41.1086 39.9209C40.5378 40.6118 39.7637 41 38.9565 41H10.0435C9.2363 41 8.46218 40.6118 7.89141 39.9209C7.32065 39.23 7 38.2929 7 37.3158V8C7 6.89543 7.89543 6 9 6H40Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28261 36.7481H39.7174",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5435 25.0217L21.4565 28.0652V21.9783L27.5435 25.0217Z",
    fill: "#D9EEF7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9565 6H10.0435C8.36261 6 7 7.36261 7 9.04348V37.9565C7 39.6374 8.36261 41 10.0435 41H38.9565C40.6374 41 42 39.6374 42 37.9565V9.04348C42 7.36261 40.6374 6 38.9565 6Z",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2827 12.087H39.7175",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0436 9.04349H11.5653",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.087 9.04349H14.6088",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4349 9.04349H38.9566",
    stroke: "#4C5B66",
    strokeWidth: 1.41667,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5922,
    cy: 36.9271,
    r: 2.18542,
    fill: "#0C131A",
    stroke: "#4C5B66"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0384 16.5682L39.0384 31.1675C39.0384 31.996 38.3669 32.6675 37.5384 32.6675H11.4617C10.6333 32.6675 9.96172 31.996 9.96172 31.1675V16.5675C9.96278 16.2525 10.0828 15.9553 10.2886 15.7394C10.4937 15.5244 10.7663 15.4077 11.0456 15.4067H37.9546C38.2339 15.4077 38.5065 15.5244 38.7116 15.7394C38.9174 15.9553 39.0374 16.2526 39.0384 16.5676C39.0384 16.5678 39.0384 16.568 39.0384 16.5682Z",
    fill: "#D05F58",
    stroke: "#5D5D5D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5931 27.5211C22.9285 27.9641 22.0384 27.4877 22.0384 26.689V21.8327C22.0384 21.034 22.9285 20.5576 23.5931 21.0007L27.2353 23.4288C27.829 23.8246 27.829 24.6971 27.2353 25.0929L23.5931 27.5211Z",
    fill: "#F0F0F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.0e618881b0021de621f862f95d0e02d1.svg";
export { ForwardRef as ReactComponent };